export const setLocationHref = (href: string) => {
    if (typeof window !== 'undefined') {
        window.location.href = href;
    } else {
        console.warn('detected server, skipping setLocationHref');
    }
};
